import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {pinIssueMutation} from './__generated__/pinIssueMutation.graphql'

export function commitPinIssueMutation({
  environment,
  input,
  repositoryId,
  currentPinnedCount,
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {issueId: string}
  repositoryId?: string
  currentPinnedCount?: number
  onCompleted?: () => void
  onError?: (error: Error) => void
}) {
  return commitMutation<pinIssueMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation pinIssueMutation($input: PinIssueInput!) @raw_response_type {
        pinIssue(input: $input) {
          issue {
            isPinned
            repository {
              pinnedIssues(first: 3) {
                totalCount
              }
            }
          }
        }
      }
    `,
    variables: {
      input,
    },
    optimisticResponse:
      repositoryId !== undefined && currentPinnedCount !== undefined
        ? {
            pinIssue: {
              issue: {
                id: input.issueId,
                isPinned: true,
                repository: {
                  id: repositoryId,
                  pinnedIssues: {
                    totalCount: currentPinnedCount + 1,
                  },
                },
              },
            },
          }
        : undefined,
    onCompleted: () => onCompleted?.(),
    onError: error => onError?.(error),
  })
}
